export interface TireMakeId {__tireMakeId: number}

export default class TireMake {
  id!: TireMakeId;
  description = '';
  isPopular = false;

  static withData(data: Partial<TireMake>): TireMake {
    return Object.assign(new TireMake(), data);
  }
}
